module.exports = __webpack_public_path__ + "img/about-us.200b8a23.jpg";